import request from '@/utils/request'


// 查询特殊倍数列表
export function listSpecialMultiple(query) {
  return request({
    url: '/user/special-multiple/list',
    method: 'get',
    params: query
  })
}

// 查询特殊倍数分页
export function pageSpecialMultiple(query) {
  return request({
    url: '/user/special-multiple/page',
    method: 'get',
    params: query
  })
}

// 查询特殊倍数详细
export function getSpecialMultiple(data) {
  return request({
    url: '/user/special-multiple/detail',
    method: 'get',
    params: data
  })
}

// 新增特殊倍数
export function addSpecialMultiple(data) {
  return request({
    url: '/user/special-multiple/add',
    method: 'post',
    data: data
  })
}

// 修改特殊倍数
export function updateSpecialMultiple(data) {
  return request({
    url: '/user/special-multiple/edit',
    method: 'post',
    data: data
  })
}

// 删除特殊倍数
export function delSpecialMultiple(data) {
  return request({
    url: '/user/special-multiple/delete',
    method: 'post',
    data: data
  })
}
